import { SxProps, Theme } from "@/common/styles/style";

export const styles: { [key: string]: SxProps<Theme> } = {
  container: {
    width: "100%",
    flexGrow: 1,
  },
  gridContainer: {
    display: "flex",
    gap: 2,
    borderRadius: "5px",
    justifyContent: "start",
  },
};
